module.exports = __webpack_public_path__ + "static/img/smart-splitter_64.8819fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-splitter_64.png
// module id = 70YK
// module chunks = 0